export const DESCRIPTIONS_BATCH_SIZE = 20

const STORAGE_KEY = 'MOG_MM_DESCRIPTIONS_V1'

const STORAGE_LIMIT = 400

export type DescriptionsMap = {[id: string]: string}

export const normalizeDescriptions = (data: any): DescriptionsMap => {
  const list = data?.descriptions ?? data?.items ?? data
  if (!Array.isArray(list)) return {}

  const result: DescriptionsMap = {}
  list.forEach((raw: any) => {
    const id = raw?.id ?? raw?.ref_id
    if (id === null || id === undefined) return
    result[String(id)] = String(raw?.description ?? '')
  })
  return result
}

export const readStoredDescriptions = (): DescriptionsMap => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    const parsed = raw ? JSON.parse(raw) : null
    return parsed && typeof parsed === 'object' ? parsed : {}
  } catch {
    return {}
  }
}

export const writeStoredDescriptions = (map: DescriptionsMap) => {
  try {
    const keys = Object.keys(map)
    const trimmed =
      keys.length > STORAGE_LIMIT
        ? keys.slice(keys.length - STORAGE_LIMIT).reduce((acc, key) => {
            acc[key] = map[key]
            return acc
          }, {} as DescriptionsMap)
        : map
    localStorage.setItem(STORAGE_KEY, JSON.stringify(trimmed))
  } catch {}
}

export const chunkIds = (ids: number[], size = DESCRIPTIONS_BATCH_SIZE) => {
  const chunks: number[][] = []
  for (let i = 0; i < ids.length; i += size) chunks.push(ids.slice(i, i + size))
  return chunks
}

export const descriptionId = (item: {
  ref_id?: number | null
}): number | null => {
  const id = Number(item?.ref_id)
  return Number.isFinite(id) && id > 0 ? id : null
}
